module.exports = __webpack_public_path__ + "media/images/lb/139-0d99b10bdf54493f7f3d7020fc984948.svg";